const common = require("lib/labels/_common");

// Home.projects

module.exports = {
  title: { 
    en: "Projects",
    fr: "Projets"
  },
  open: {
    en: "Open",
    fr: "Ouvrir"
  },
  join: {
    en: "Join",
    fr: "Rejoindre"
  },
  detailed: {
    name: common.name,
    description: common.description,
    users: common.users,
    app: {
      en: "Apps",
      fr: "Apps"
    },
    services: {
      en: "Services",
      fr: "Services"
    },
    files: {
      en: "Files",
      fr: "Fichiers"
    },
    licences: {
      en: "Licences",
      fr: "Licences"
    }
  }
};
